import { ArrowRight, CheckCircle2, ShieldCheck, Clock, Layers, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function IntroducciN() {
  const heroImgUrl = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/professional-customer-service-team-in-a-fc564c.png";
  return <section data-section-id="263978" id="introduccion" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold font-default text-foreground mb-6 leading-tight tracking-tight">
              Su empresa pierde dinero cada vez que un cliente espera.{" "}
              <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                La IA en sus canales de comunicación lo evita.
              </span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-muted-foreground mb-6 leading-relaxed font-default">
              En AVTECSA primero investigamos dónde su empresa pierde dinero, tiempo, clientes u oportunidades de venta, y luego lo automatizamos con inteligencia artificial en WhatsApp, chat, llamadas y correo, para ahorrar recursos y atender mejor.
            </p>

            {/* Benefit chips / checks */}
            <div className="flex flex-wrap items-center gap-3 sm:gap-4 mb-8">
              <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-accent text-accent-foreground border border-border">
                <CheckCircle2 className="size-4 text-primary shrink-0" />
                Ahorre tiempo
              </span>
              <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-accent text-accent-foreground border border-border">
                <CheckCircle2 className="size-4 text-primary shrink-0" />
                Reduzca costos
              </span>
              <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-accent text-accent-foreground border border-border">
                <CheckCircle2 className="size-4 text-primary shrink-0" />
                Atienda mejor a sus clientes
              </span>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-10">
              <Button size="lg" className="bg-yellow-400 text-black hover:bg-yellow-500 rounded-md px-6 py-6 text-sm sm:text-base font-bold uppercase tracking-wider shadow-lg shadow-yellow-400/20 animate-pulse text-center justify-center" asChild>
                <Link to="#contacto">
                  Descubra dónde pierde dinero
                  <ArrowRight className="ml-2 size-5 shrink-0" />
                </Link>
              </Button>

              <Button variant="outline" size="lg" className="rounded-md px-6 py-6 text-sm sm:text-base font-semibold border-border hover:border-primary hover:text-primary transition-colors text-center justify-center" asChild>
                <Link to="#perdidas">
                  Ver qué pierde su empresa
                </Link>
              </Button>
            </div>

            {/* Trust strip */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6 border-t border-border">
              <div className="flex items-center gap-3">
                <div className="size-8 rounded-full bg-primary flex items-center justify-center shrink-0">
                  <ShieldCheck className="size-4 text-white" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-foreground">
                  Precios transparentes, sin cargos por tokens
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="size-8 rounded-full bg-primary flex items-center justify-center shrink-0">
                  <Clock className="size-4 text-white" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-foreground">
                  Soporte 24/7
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="size-8 rounded-full bg-primary flex items-center justify-center shrink-0">
                  <Layers className="size-4 text-white" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-foreground">
                  WhatsApp, llamadas, chat y correo en un solo lugar
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="size-8 rounded-full bg-primary flex items-center justify-center shrink-0">
                  <Cpu className="size-4 text-white" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-foreground">
                  Integración con sus sistemas
                </span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="lg:col-span-5 relative mt-4 lg:mt-0">
            <div className="relative aspect-[4/3] lg:aspect-[4/5] overflow-hidden rounded-md shadow-xl border border-border">
              <img src={heroImgUrl} data-wvc-srcset={`${heroImgUrl}-wvc-srcset`} data-wvc-sizes={`${heroImgUrl}-wvc-sizes`} alt="Equipo profesional de atención al cliente utilizando soluciones de inteligencia artificial" className="w-full h-full object-cover object-center" loading="lazy" />
              {/* Soft blue overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />

              {/* Floating glass card */}
              <div className="absolute bottom-4 left-4 right-4 sm:right-auto sm:max-w-xs bg-background/90 backdrop-blur-md border border-border rounded-md p-4 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="size-3 rounded-full bg-chart-3 animate-ping" />
                  <div>
                    <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                      Canales automatizados
                    </p>
                    <p className="text-sm font-bold text-foreground">
                      Respuesta inmediata, 24/7
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}